module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjMDc4OTMwIiBkPSJNMCAwaDkwMHY2MDB6Ii8+PHBhdGggZmlsbD0iI0ZDREQwOSIgZD0iTTAgMGw5MDAgNjAwSDB6Ii8+PHBhdGggZmlsbD0iI0RBMTIxQSIgZD0iTTQ1MCAyMDBsNTguNzc5IDE4MC45MDItMTUzLjg4NS0xMTEuODA0aDE5MC4yMTJMMzkxLjIyIDM4MC45MDJ6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/guf.svg
// module id = KBIZ
// module chunks = 0